(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initTabbedContent(section) {
      if (!section) return;

      const tabButtons = section.querySelectorAll('[data-tab-button]');
      const tabPanels = section.querySelectorAll('[data-tab-panel]');

      function switchTab(button) {
        const tabId = button.dataset.tabTarget;
        
        tabPanels.forEach(panel => {
          const isActive = panel.dataset.tabPanel === tabId;
          panel.hidden = !isActive;
          panel.classList.toggle('active', isActive);
        });

        tabButtons.forEach(btn => {
          const isActive = btn.dataset.tabTarget === tabId;
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-selected', isActive);
        });
      }

      tabButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          switchTab(this);
        });
      });
    }

    document.querySelectorAll('[data-section-type="tabbed-content"]').forEach(initTabbedContent);

    document.addEventListener('shopify:section:load', function(event) {
      const section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
      if (section && section.dataset.sectionType === 'tabbed-content') {
        initTabbedContent(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
